export class PlansDto {
  iContractRid: number;
  StartDate: string;
  EndDate: string;
  Status: number;
  iLimit: number;
  iOffset: number;
}
